import React, { FC, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';

import { Button, Modal, Theme } from '../../../components';
import { usersActions, usersSelectors } from '../../../redux';

interface Props {
  isOpen: boolean;
  closeModal: () => void;
  deleteId: string;
}

const DeleteUser: FC<Props> = ({ isOpen, deleteId, closeModal }) => {
  const dispatch = useDispatch();
  const { t } = useTranslation();

  const isDeleteLoading = useSelector(usersSelectors.isDeleteLoading);
  const [hasConfirmed, setHasConfirmed] = useState<boolean>(false);

  useEffect(() => {
    if (hasConfirmed && !isDeleteLoading) {
      closeModal();
      setHasConfirmed(false);
    }
  }, [isDeleteLoading]);

  const deleteUser = () => {
    setHasConfirmed(true);
    dispatch(usersActions.deleteUser(deleteId));
  };

  return (
    <Modal title={t('titleDeleteUser')} isOpen={isOpen} closeModal={() => closeModal()}>
      <div className='add-edit-container'>
        <p className='description'>{t('lblDeleteUser')}</p>
        <div className='buttons'>
          <Button theme={Theme.INVERSE} onClickCallback={closeModal}>
            {t('lblCancel')}
          </Button>
          <Button icon='Trashcan' theme={Theme.DESTRUCTIVE} onClickCallback={deleteUser} isLoading={isDeleteLoading}>
            {t('lblDelete')}
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default DeleteUser;
